{
    "title": "Vorlagen",
    "subtitle": "Wählen Sie eine Tagebuch-Einrichtung"
}
